module.exports = __webpack_public_path__ + "img/盖章.f5d38b0a.jpg";